import React from "react";
import Link from "gatsby-link";
import Img from "gatsby-image";
import PropTypes from "prop-types";

import Time from "../Time/index.jsx";
import { rhythm } from "../../utils/typography";

// https://stackoverflow.com/questions/19307443/semantic-html-of-an-articles-list
const ArticlePreview = ({ post, displayImages }) => <article className="blog-post-preview" style={{ marginBottom: rhythm(1.5) }}>
    {displayImages &&
      post.frontmatter.cover &&
        <Img sizes={post.frontmatter.cover.childImageSharp.sizes} />
      }
    <h2>
      <Link className="no-underline" to={post.frontmatter.path}>
        {post.frontmatter.title}
      </Link>
    </h2>
    <Time date={post.frontmatter.date} />
    <p style={{ marginBottom: rhythm(1 / 3) }}>{post.excerpt}</p>
  </article>;

ArticlePreview.propTypes = {
  displayImages: PropTypes.bool,
  post: PropTypes.shape({
    excerpt: PropTypes.string.isRequired,
    frontmatter: PropTypes.shape({
      tags: PropTypes.array,
      date: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      cover: PropTypes.object
    })
  })
};

export default ArticlePreview;



// WEBPACK FOOTER //
// ./src/components/ArticlePreview/index.jsx